
import { Props } from './interfaces';
import './LinkBig.scss';
import './LinkBig-media.scss';
import { RefObject, createRef } from 'react';
import { HoverButton } from '../Button/Button';
import {Link} from "../Link/Link";

const LinkBig = ({ link, text }: Props) => {
  const elLink: RefObject<HTMLAnchorElement> = createRef();
  const elSpan: RefObject<HTMLSpanElement> = createRef();

  return (
    <Link
      to={link}
      className="link-big"
      ref={elLink}
      onMouseEnter={HoverButton(elLink, elSpan)}
      onMouseOut={HoverButton(elLink, elSpan)}
    >
      <h4>{text}</h4>
      <span ref={elSpan}></span>
    </Link>
  );
};

export default LinkBig;
